'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _blocks = require('../../blocks');

var _Head = require('./Head');

var _Head2 = _interopRequireDefault(_Head);

var _Row = require('./Row');

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: also extract Cell rendering in order
// to prevent unnecessary re-renders of those.


var defaultRowModifiers = [];

var DataTable = function (_Component) {
  _inherits(DataTable, _Component);

  function DataTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DataTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call.apply(_ref, [this].concat(args))), _this), _this.renderHeaderCell = function (column, colIndex) {
      var headerCellAttrsGetter = column.headerCellAttrsGetter || _lodash.noop;
      var _this$props = _this.props,
          tableData = _this$props.tableData,
          onHeaderCellClick = _this$props.onHeaderCellClick;


      return _react2.default.createElement(
        _blocks.Table.HeaderCell,
        _extends({
          key: column.name,
          style: _extends({}, column.cellStyles, column.width ? { width: column.width } : {}),
          onClick: function onClick() {
            return onHeaderCellClick({ column: column, colIndex: colIndex, tableData: tableData });
          }
        }, headerCellAttrsGetter({ colIndex: colIndex, tableData: tableData })),
        column.headerCellRenderer(column, { colIndex: colIndex })
      );
    }, _this.renderRow = function (rowData, rowIndex) {
      var _this$props2 = _this.props,
          columns = _this$props2.columns,
          tableData = _this$props2.tableData,
          rowKeyGetter = _this$props2.rowKeyGetter,
          tableMetaData = _this$props2.tableMetaData,
          shouldRowUpdate = _this$props2.shouldRowUpdate,
          rowModifiersGetter = _this$props2.rowModifiersGetter;


      var rowProps = {
        columns: columns,
        rowData: rowData,
        rowIndex: rowIndex,
        tableData: tableData,
        tableMetaData: tableMetaData,
        shouldUpdate: shouldRowUpdate,
        modifiers: rowModifiersGetter(rowData, rowIndex),
        cellRenderer: _this.renderCell
      };

      return _react2.default.createElement(_Row2.default, _extends({ key: rowKeyGetter(rowData, rowIndex) }, rowProps));
    }, _this.renderCell = function (column, _ref2) {
      var colIndex = _ref2.colIndex,
          rowIndex = _ref2.rowIndex,
          rowData = _ref2.rowData;
      var _this$props3 = _this.props,
          tableData = _this$props3.tableData,
          tableMetaData = _this$props3.tableMetaData;

      var dataCellAttrsGetter = column.dataCellAttrsGetter || _lodash.noop;
      var cellContent = column.dataCellRenderer(column.cellDataGetter(rowData), { tableData: tableData, tableMetaData: tableMetaData, rowData: rowData, rowIndex: rowIndex, colIndex: colIndex });

      if (!cellContent) {
        return null;
      }

      return _react2.default.createElement(
        _blocks.Table.DataCell,
        _extends({
          key: column.cellKeyGetter(rowData),
          style: column.cellStyles
        }, dataCellAttrsGetter({ rowIndex: rowIndex, colIndex: colIndex, rowData: rowData, tableData: tableData })),
        cellContent
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DataTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          columns = _props.columns,
          scrollX = _props.scrollX,
          tableData = _props.tableData,
          shouldHeadUpdate = _props.shouldHeadUpdate,
          rowModifiersGetter = _props.rowModifiersGetter,
          rest = _objectWithoutProperties(_props, ['columns', 'scrollX', 'tableData', 'shouldHeadUpdate', 'rowModifiersGetter']);

      return _react2.default.createElement(
        _blocks.Table.Container,
        _extends({ modifiers: [scrollX && 'scrollX'] }, rest),
        _react2.default.createElement(
          _blocks.Table,
          _extends({ modifiers: ['fillHeight', 'scrollBodyY'] }, rest),
          _react2.default.createElement(_Head2.default, {
            columns: columns,
            shouldUpdate: shouldHeadUpdate,
            cellRenderer: this.renderHeaderCell,
            rowModifiers: rowModifiersGetter()
          }),
          _react2.default.createElement(
            _blocks.Table.Body,
            null,
            tableData.map(this.renderRow)
          )
        )
      );
    }
  }]);

  return DataTable;
}(_react.Component);

DataTable.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    width: _propTypes2.default.string,
    cellStyles: _propTypes2.default.object,
    cellKeyGetter: _propTypes2.default.func.isRequired,
    cellDataGetter: _propTypes2.default.func.isRequired,
    headerCellRenderer: _propTypes2.default.func.isRequired,
    headerCellAttrsGetter: _propTypes2.default.func,
    dataCellRenderer: _propTypes2.default.func.isRequired,
    dataCellAttrsGetter: _propTypes2.default.func
  })).isRequired,
  onHeaderCellClick: _propTypes2.default.func,
  rowKeyGetter: _propTypes2.default.func,
  rowModifiersGetter: _propTypes2.default.func,
  scrollX: _propTypes2.default.bool,
  shouldHeadUpdate: _propTypes2.default.func,
  /**
   * This allows devs to put logic in place to prevent rows from
   * re-rendering when not necessary. This gets called for each
   * row with its current and next props as arguments.
   */
  shouldRowUpdate: _propTypes2.default.func,
  tableData: _propTypes2.default.arrayOf(_propTypes2.default.object),
  tableMetaData: _propTypes2.default.shape()
};
DataTable.defaultProps = {
  onHeaderCellClick: _lodash.noop,
  rowKeyGetter: function rowKeyGetter(rowData) {
    return rowData.key || rowData.id;
  },
  rowModifiersGetter: function rowModifiersGetter() {
    return defaultRowModifiers;
  },
  scrollX: false,
  shouldHeadUpdate: function shouldHeadUpdate() {
    return false;
  },
  shouldRowUpdate: function shouldRowUpdate() {
    return true;
  },
  tableData: [],
  tableMetaData: undefined
};
exports.default = DataTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/DataTable/index.js
// module id = 1628
// module chunks = 2